<template>
  <v-container style="min-height: calc(100vh - 80px);">
    <v-row>
      <v-col cols="12" md="4">
        <v-autocomplete
          v-model="filter.category"
          :items="listcategory"
          label="Category"
          name="category">
        </v-autocomplete>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          prepend-inner-icon="search"
          v-model="paramberita.keyword"
          label="Gallery name"
          name="keyword">
        </v-text-field>
      </v-col>
      <v-col cols="12" md="2">
        <v-btn
          type="submit"
          large
          :color="maincolor"
          class="mt-1 white--text"
          block
          @click="getGalleryFilter">
          <v-icon left>search</v-icon> Search
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="12">
        <v-card outlined>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                md="3"
                v-for="(image, i) in imagesslide"
                :key="i"
                class="class-cursor">
                <v-img
                  :lazy-src="require('../assets/default.jpg')"
                  :src="image"
                  @click="indexslide = i"
                  class="rounded-lg"
                  aspect-ratio="1.7">
                </v-img>
              </v-col>
              <v-col cols="12" md="12">
                <vue-gallery-slideshow
                  :images="imagesslide"
                  :index="indexslide"
                  @close="indexslide = null">
                </vue-gallery-slideshow>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../components/Alert.vue';
import InfiniteLoading from 'vue-infinite-loading';
import { mapState } from 'vuex';
import VueGallerySlideshow from 'vue-gallery-slideshow';

export default {
  name: 'Gallery',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      check: false,
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    publickey: '123',
    listlocation: ['BADUNG', 'DENPASAR', 'GIANYAR', 'TABANAN'],
    listcategory: ['Job Fair', 'Company', 'Kerja Sama'],
    datalist: [],
    listjenisdata: [],
    listkecamatan: [],
    panduan: null,
    paramberita: {
      keyword: '',
      limit: 20,
      offset: 0,
    },
    filter: {
      location: '',
      jenisdata: '',
      year: [],
      olahraga: '',
      tingkat: '',
      kelamin: '',
      kecamatan: '',
      kelurahan: '',
      gaji: [3, 7],
    },
    check: {
      reference: '',
    },
    formcheck: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
    },
    hasil: {
      headers: [
        { text: 'Tahun', value: 'tahun_prestasi' },
        { text: 'Peringkat', value: 'juara_prestasi' },
        { text: 'Tingkat', value: 'tingkat_prestasi' },
      ],
      data: [],
    },
    infiniteId: +new Date(),
    imagesslide: [
      require('./../assets/virtualjobfair.jpg'),
      'https://bursakerja-api.maderiyan.com/images/1.jpg',
      'https://bursakerja-api.maderiyan.com/images/2.jpg',
      'https://bursakerja-api.maderiyan.com/images/3.jpg',
      'https://bursakerja-api.maderiyan.com/images/4.jpg',
      'https://bursakerja-api.maderiyan.com/images/5.jpg',
      'https://bursakerja-api.maderiyan.com/images/6.jpg',
      'https://bursakerja-api.maderiyan.com/images/7.jpg',
      'https://bursakerja-api.maderiyan.com/images/8.jpg',
      'https://bursakerja-api.maderiyan.com/images/9.jpg',
      'https://bursakerja-api.maderiyan.com/images/10.jpg',
      'https://bursakerja-api.maderiyan.com/images/11.jpg',
      'https://bursakerja-api.maderiyan.com/images/12.jpg',
      'https://bursakerja-api.maderiyan.com/images/13.jpg',
      'https://bursakerja-api.maderiyan.com/images/14.jpg',
    ],
    indexslide: null,
  }),
  mounted() {
    // this.getBeritaFilter();
    if (this.$route.query.reference && this.$route.query.reference !== '') {
      this.check.reference = this.$route.query.reference;
      // this.checkAtletByNik();
    }
  },
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
    ]),
  },
  methods: {
    getGalleryFilter() {
      console.log('get gallery');
    },
    getBeritaFilter() {
      this.paramberita.offset = 0;
      this.datalist = [];
      this.infiniteId += 1;
    },
    getBerita($state) {
      this.axios
        .get(
          this.api + '/public/company',
          {
            params: this.paramberita,
            headers: {
              Authorization: 'bearer ' + this.publickey,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.error === false) {
              if (resdata.data.length > 0) {
                this.paramberita.offset += this.paramberita.limit;
                resdata.data.forEach((element) => {
                  element.urlpic = this.api + '/upload/avatar/' + element.com_picture;
                  this.datalist.push(element);
                });
                // this.datalist.push(...resdata.data);
                if (this.datalist.length < this.paramberita.offset) {
                  $state.complete();
                } else {
                  $state.loaded();
                }
              } else {
                $state.complete();
              }
            }
          }
          // this.loading.check = false;
        })
        .catch((error) => {
          console.log(error);
          // this.loading.check = false;
        });
    },
    checkAtletByNik() {
      this.alertdata.show = false;
      if (this.check.reference !== '') {
        this.hasil.data = [];
        this.loading.check = true;
        this.axios
          .post(
            this.api + '/public/checkdata',
            qs.stringify(
              this.check,
            ),
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'bearer ' + this.publickey,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.hasil.data = resdata.data;
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.check = false;
          })
          .catch((error) => {
            console.log(error);
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
            this.loading.check = false;
          });
      }
    },
    submitCheckData() {
      this.alertdata.show = false;
      if (this.$refs.formcheck.validate()) {
        // this.checkAtletByNik();
      }
    },
  },
  components: {
    Alertsp,
    InfiniteLoading,
    VueGallerySlideshow,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
